import useQueryURL from "../../../common/hooks/useQueryURL";
import { useAuth } from "../../auth/hooks";
import  { BASE_URL_CULK } from "../services/createUserLinkAPI";

import {
  CreateUserLink,
  CreateUserLinkPatch,
} from "../types/createUserLink.type";

import { useSingleGenericAPI } from "../../../utils/genericAPI/useGenericAPI";

/**
 * useSingleCreateUserLink is a hook that returns a single create user link.
 *
 * @param id
 * @returns
 */
export default function useSingleCreateUserLink(id?: string) {
  const { getQueryValue } = useQueryURL();
  const idFromURL = getQueryValue("createUserLinkId");
  const idFound = id || idFromURL;

  if (!idFound) {
    console.error("useSingleCreateUserLink: createUserLinkId is required");
  }
  return useSingleCreateUserLinkCore({ createUserLinkId: idFound || "" });
}

interface SingleCreateUserLinkCoreConfig {
  createUserLinkId: string;
}

const useSingleCreateUserLinkCore = ({
  createUserLinkId,
}: SingleCreateUserLinkCoreConfig) => {
  const { setHeaderAuthToRequest } = useAuth();
  setHeaderAuthToRequest();
  const {singleQuery, deleteQuery} = useSingleGenericAPI<CreateUserLink, CreateUserLinkPatch>({
    baseURL: BASE_URL_CULK,
    APIname: "createUserLinks",
    id: createUserLinkId,
  })
  return {
    createUserLinkId,
    singleCreateUserLinkQuery: singleQuery,
    deleteSingleCreateUserLink: deleteQuery,
  };
};
